<template>
  <div class="tw-flex tw-flex-wrap tw-gap-sm lg:tw-max-w-[200px] xl:tw-max-w-none">
    <WdsLabel primary subtle sm>
      {{ $t('Skills added by company') }}
    </WdsLabel>
    <WdsLabel subtle sm :disabled="showOnlyCompanySkills">
      <WdsStack align-center>
        <WdsIcon :name="showOnlyCompanySkills ? 'view-off' : 'view'" :size="14" class="tw-me-1" />
        {{ $t('Added by worker') }}
      </WdsStack>
    </WdsLabel>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { WdsIcon, WdsLabel, WdsStack } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTrustedContactsStore } from '@/components/GraphqlDataTable/filters/trustedContacts/trusted-contacts-store'

const { showOnlyCompanySkills } = storeToRefs(useTrustedContactsStore())
</script>
